import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export type GretaIconVariant = 'yellow' | 'white' | 'black' | 'blackYellow';

export function IconGreta24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="23"
            viewBox="0 0 230 220"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Greta">
            <path
                d="M120.006 0C180.758 0 230.006 49.2487 230.006 110C230.006 170.751 180.758 220 120.006 220C93.9839 220 70.0727 210.963 51.2378 195.857L1.00635 202.5L24.9497 165.387C15.451 149.12 10.0063 130.196 10.0063 110C10.0063 49.2487 59.255 0 120.006 0ZM88.0063 163C83.8642 163 80.5063 166.358 80.5063 170.5C80.5063 174.642 83.8642 178 88.0063 178H153.006C157.148 178 160.506 174.642 160.506 170.5C160.506 166.358 157.148 163 153.006 163H88.0063ZM63.0063 130C58.8642 130 55.5063 133.358 55.5063 137.5C55.5063 141.642 58.8642 145 63.0063 145H177.506C181.648 145 185.006 141.642 185.006 137.5C185.006 133.358 181.648 130 177.506 130H63.0063ZM110.15 40.1914C108.824 39.2673 107.006 40.2158 107.006 41.832V104.572C107.006 106.207 108.861 107.151 110.183 106.189L154.235 74.1523C155.347 73.3437 155.33 71.6797 154.202 70.8936L110.15 40.1914Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconGretaYellow24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="23"
            viewBox="0 0 230 220"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Greta">
            <path
                d="M120.006 0C180.758 0 230.006 49.2487 230.006 110C230.006 170.751 180.758 220 120.006 220C93.9839 220 70.0727 210.963 51.2378 195.857L1.00635 202.5L24.9497 165.387C15.451 149.12 10.0063 130.196 10.0063 110C10.0063 49.2487 59.255 0 120.006 0ZM88.0063 163C83.8642 163 80.5063 166.358 80.5063 170.5C80.5063 174.642 83.8642 178 88.0063 178H153.006C157.148 178 160.506 174.642 160.506 170.5C160.506 166.358 157.148 163 153.006 163H88.0063ZM63.0063 130C58.8642 130 55.5063 133.358 55.5063 137.5C55.5063 141.642 58.8642 145 63.0063 145H177.506C181.648 145 185.006 141.642 185.006 137.5C185.006 133.358 181.648 130 177.506 130H63.0063ZM110.15 40.1914C108.824 39.2673 107.006 40.2158 107.006 41.832V104.572C107.006 106.207 108.861 107.151 110.183 106.189L154.235 74.1523C155.347 73.3437 155.33 71.6797 154.202 70.8936L110.15 40.1914Z"
                fill="#FFE500"
            />
        </svg>
    );
}

export function IconGretaWhite24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="23"
            viewBox="0 0 230 220"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Greta">
            <path
                d="M120.006 0C180.758 0 230.006 49.2487 230.006 110C230.006 170.751 180.758 220 120.006 220C93.9839 220 70.0727 210.963 51.2378 195.857L1.00635 202.5L24.9497 165.387C15.451 149.12 10.0063 130.196 10.0063 110C10.0063 49.2487 59.255 0 120.006 0ZM88.0063 163C83.8642 163 80.5063 166.358 80.5063 170.5C80.5063 174.642 83.8642 178 88.0063 178H153.006C157.148 178 160.506 174.642 160.506 170.5C160.506 166.358 157.148 163 153.006 163H88.0063ZM63.0063 130C58.8642 130 55.5063 133.358 55.5063 137.5C55.5063 141.642 58.8642 145 63.0063 145H177.506C181.648 145 185.006 141.642 185.006 137.5C185.006 133.358 181.648 130 177.506 130H63.0063ZM110.15 40.1914C108.824 39.2673 107.006 40.2158 107.006 41.832V104.572C107.006 106.207 108.861 107.151 110.183 106.189L154.235 74.1523C155.347 73.3437 155.33 71.6797 154.202 70.8936L110.15 40.1914Z"
                fill="white"
            />
        </svg>
    );
}

export function IconGretaBlack24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="23"
            viewBox="0 0 230 220"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Greta">
            <path
                d="M120.006 0C180.758 0 230.006 49.2487 230.006 110C230.006 170.751 180.758 220 120.006 220C93.9839 220 70.0727 210.963 51.2378 195.857L1.00635 202.5L24.9497 165.387C15.451 149.12 10.0063 130.196 10.0063 110C10.0063 49.2487 59.255 0 120.006 0ZM88.0063 163C83.8642 163 80.5063 166.358 80.5063 170.5C80.5063 174.642 83.8642 178 88.0063 178H153.006C157.148 178 160.506 174.642 160.506 170.5C160.506 166.358 157.148 163 153.006 163H88.0063ZM63.0063 130C58.8642 130 55.5063 133.358 55.5063 137.5C55.5063 141.642 58.8642 145 63.0063 145H177.506C181.648 145 185.006 141.642 185.006 137.5C185.006 133.358 181.648 130 177.506 130H63.0063ZM110.15 40.1914C108.824 39.2673 107.006 40.2158 107.006 41.832V104.572C107.006 106.207 108.861 107.151 110.183 106.189L154.235 74.1523C155.347 73.3437 155.33 71.6797 154.202 70.8936L110.15 40.1914Z"
                fill="#1A1A18"
            />
        </svg>
    );
}

export function IconGretaBlackYellow24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="23"
            viewBox="0 0 230 223"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="Greta">
            <path
                d="M118.597 0C57.0654 0 7.1383 49.9271 7.1383 111.458C7.1383 132.034 12.8429 151.244 22.5455 167.821L0.604867 203.17C0.604867 203.17 -1.34541 205.754 1.77503 205.169C4.06661 204.73 32.0531 199.806 47.2653 197.124C66.573 213.214 91.4391 222.917 118.548 222.917C180.128 222.917 230.006 173.038 230.006 111.458C230.006 49.8784 180.177 0 118.597 0Z"
                fill="#1A1A18"
            />
            <path
                d="M151.606 165.189H86.5158C82.7127 165.189 79.5923 168.309 79.5923 172.112C79.5923 175.915 82.664 179.036 86.5158 179.036H151.606C155.458 179.036 158.53 175.964 158.53 172.112C158.53 168.26 155.458 165.189 151.606 165.189Z"
                fill="#FFE500"
            />
            <path
                d="M109.041 106.193L152.63 75.037C154.19 73.9156 154.19 72.1116 152.63 70.9902L109.041 39.8345C107.481 38.7131 106.213 39.3957 106.213 41.2972V104.73C106.213 106.632 107.481 107.314 109.041 106.193Z"
                fill="#FFE500"
            />
            <path
                d="M177.008 132.326H60.2355C56.4325 132.326 53.312 135.398 53.312 139.25C53.312 143.102 56.4325 146.173 60.2355 146.173H177.008C180.811 146.173 183.932 143.102 183.932 139.25C183.932 135.398 180.811 132.326 177.008 132.326Z"
                fill="#FFE500"
            />
        </svg>
    );
}

export function GretaIcon({
    variant = 'blackYellow',
    ...props
}: { variant?: GretaIconVariant } & CustomSVGProps): React.JSX.Element {
    switch (variant) {
        case 'yellow':
            return <IconGretaYellow24 {...props} />;
        case 'white':
            return <IconGretaWhite24 {...props} />;
        case 'black':
            return <IconGretaBlack24 {...props} />;
        case 'blackYellow':
        default:
            return <IconGretaBlackYellow24 {...props} />;
    }
}
